export interface TronBlock {
    block_header: {
        raw_data: {
            number: number;
        };
    };
}
